import { useState, useEffect, useCallback } from "react";
import equal from "fast-deep-equal";
const useGridSorting = ({
  sortModel: sortModelProp,
  sortingMode,
  columns,
  onSortModelChange
}) => {
  const sortModel = sortModelProp?.length > 0 ? [sortModelProp[0]] : [];
  const [gridSortModel, setGridSortModel] = useState(() => getInitGridSortModel(sortModel));
  function getInitGridSortModel(sortModel2) {
    let result = sortModel2 ?? [];
    if (!sortModel2?.length) {
      const sortColumns = columns?.filter((c) => c?.sortField) ?? [columns.find((c) => c.sortable)] ?? [columns.find((c) => !c.hide)];
      if (sortColumns.length) {
        result = [
          ...sortColumns.map((sortColumn) => ({
            field: columns.find((c) => c.field === sortColumn.sortField)?.field ?? sortColumn.field,
            sort: sortColumn.sortDirection ?? "desc"
          }))
        ];
      }
    }
    return result;
  }
  useEffect(() => {
    if (!equal(sortModel, gridSortModel)) {
      setGridSortModel(sortModel);
    }
  }, [sortModelProp?.length, sortModelProp?.map((m) => `${m.field}_${m.sort}`).join(",")]);
  const fields = columns.map((c) => c.field);
  const sortables = columns.map((c) => c.sortable);
  const handleSortModelChange = useCallback(
    (model) => {
      if (onSortModelChange) {
        setGridSortModel(model);
        onSortModelChange({ sortModel: model, columns, api: void 0 });
      }
    },
    [onSortModelChange, `${fields}`, `${sortables}`]
  );
  return {
    sortingMode: sortingMode ?? "client",
    sortModel: gridSortModel,
    onSortModelChange: handleSortModelChange
  };
};
export {
  useGridSorting
};
//# sourceMappingURL=useGridSorting.js.map
